<div
  class="logo-container"
  (click)="navigateToProjects()"
  role="button"
  tabindex="0"
>
  <img
    src="assets/images/logo.svg"
    alt="Enlighten Logo"
    class="h-[40px] w-auto logo-image"
  />
</div>
